import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DocumentInterface } from 'src/app/model/documents/document-interface';
import { OrganisationService } from '../organisation-service/organisationservice';
import { UserService } from '../../user-service/userservice';
import { API_BASE_PRODUCTSERVICE, API_MAP } from 'src/environments/api';

const SWARM_API = API_BASE_PRODUCTSERVICE;
const SWARM_DOC_API = SWARM_API + '/documents/';

@Injectable()
export class DocumentService {
    constructor(
        private http: HttpClient,
        private organisationService: OrganisationService,
        private userService: UserService
    ) {}

    getDocument(documentId, isCertification?: boolean) {
        let headers = new Headers();
        headers.append('Content-Type', 'application/x-pdf');

        if (!this.userService.isAuthorized('system', 'nutzerrechte')) {
            return;
        }
        return this.http.get<DocumentInterface>(
            '/proxy/api/v0/productservice/documents/' + documentId + '/content'
        );
    }

    getDocumentsRelatedToProductList(productId) {
        let headers = new Headers();
        headers.append('Content-Type', 'application/x-pdf');

        if (
            this.userService.currentUserAuthorizedActions &&
            !this.userService.isAuthorized('system', 'nutzerrechte')
        ) {
            return;
        }
        return this.http.get<DocumentInterface[]>(
            SWARM_DOC_API + 'products/' + productId
        );
    }

    getDocumentsRelatedToCertificationList(certificationId) {
        let headers = new Headers();
        headers.append('Content-Type', 'application/x-pdf');

        if (
            this.userService.currentUserAuthorizedActions &&
            !this.userService.isAuthorized('system', 'nutzerrechte')
        ) {
            return;
        }
        return this.http.get<DocumentInterface[]>(
            SWARM_DOC_API + 'certifications/' + certificationId
        );
    }

    deleteDocument(documentId: number) {
        if (
            !this.userService.isAuthorized(
                this.organisationService.activeItem.organisationId,
                'deleteDocument'
            )
        ) {
            alert(
                'missingPermission to Delete Document\n document.service.ts:51'
            );
            return;
        }
        this.http
            .delete<DocumentInterface>(
                API_BASE_PRODUCTSERVICE +
                    API_MAP['documents']['DELETE']
                        .replace(':documentId', documentId + '')
                        .replace(
                            ':organisationId',
                            this.organisationService.activeItem.organisationId +
                                ''
                        )
            )
            .subscribe();
    }
}
